import * as yup from 'yup'

export default yup.object().shape({
  authCode: yup
    .object()
    .shape({
      one: yup.number().typeError('Enter number').required(),
      two: yup.number().typeError('Enter number').required(),
      three: yup.number().typeError('Enter number').required(),
      four: yup.number().typeError('Enter number').required(),
    })
    .required()
    .label('Authentication code'),
})
